import { render, staticRenderFns } from "./CategoryNav.vue?vue&type=template&id=14229615&scoped=true"
import script from "./CategoryNav.vue?vue&type=script&lang=js"
export * from "./CategoryNav.vue?vue&type=script&lang=js"
import style0 from "./CategoryNav.vue?vue&type=style&index=0&id=14229615&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14229615",
  null
  
)

export default component.exports